import { BigNumber } from '@ethersproject/bignumber'
import { Contract } from '@ethersproject/contracts'
import { useCallback, useEffect, useState } from 'react'
import ERC20_ABI from '../constants/abis/shibaswap_erc20.json'
import { useContract } from '../hooks/useContract'
import { useBlockNumber } from '../hooks/useBlockNumber'
import { isAddress } from '../utils'
import { useAccount } from 'wagmi'

export interface BalanceProps {
    value: BigNumber
    decimals: number
    isLoading?: boolean
}

const useShibaSwapTokenBalance = (tokenAddress: string) => {
    const [balance, setBalance] = useState<BalanceProps>({ value: BigNumber.from(0), decimals: 18, isLoading: true })
    const { address: account } = useAccount()
    const currentBlockNumber = useBlockNumber()
    const addressCheckSum = isAddress(tokenAddress)
    const tokenContract = useContract(addressCheckSum ? addressCheckSum : undefined, ERC20_ABI, false)

    const getBalance = async (contract: Contract | null, owner: string | null | undefined): Promise<BalanceProps> => {
        try {
            const balance = await contract?.balanceOf(owner)
            const decimals = await contract?.decimals()
            return { value: BigNumber.from(balance), decimals: decimals, isLoading: false }
        } catch (e) {
            console.log('getBalance_error:', e)
            return { value: BigNumber.from(0), decimals: 18, isLoading: false }
        }
    }

    const fetchBalance = useCallback(async () => {
        const balance = await getBalance(tokenContract, account)
        setBalance(balance)
    }, [account, tokenContract])

    useEffect(() => {
        if (account && tokenContract) {
            fetchBalance()
        }
    }, [account, setBalance, currentBlockNumber, tokenAddress, fetchBalance, tokenContract])

    return balance
}

export default useShibaSwapTokenBalance
